import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractTranslatedApiErrorMessage } from '../../shared/utils/translate-api-error.util';
import { Tax } from '../types/tax.type';
import { UpdateTaxRequestDTO } from '../types/dtos/update-tax.dto';
import { ADMIN_TAXES_API_PATHS } from '../constants/taxes-api-paths.constants';

type UseUpdateTaxResult = {
  updateTax: (taxId: string, taxData: UpdateTaxRequestDTO) => Promise<Tax | null>;
  isSubmitting: boolean;
};

export function useUpdateTax(): UseUpdateTaxResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const updateTax = async (taxId: string, taxData: UpdateTaxRequestDTO): Promise<Tax | null> => {
    setIsSubmitting(true);

    try {
      const updatedTax = await HttpClient.patch<Tax, UpdateTaxRequestDTO>(
        ADMIN_TAXES_API_PATHS.UPDATE_TAX(taxId),
        taxData
      );

      enqueueSnackbar('La taxe a été modifiée', { variant: 'success' });
      return updatedTax;
    } catch (error) {
      enqueueSnackbar(
        extractTranslatedApiErrorMessage(error, 'Une erreur est survenue lors de la modification de la taxe'),
        { variant: 'error' }
      );
      return null;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { updateTax, isSubmitting };
}
